module.exports = __webpack_public_path__ + "static/media/promstore.cf5a6dcd.png";